import React, { Component } from 'react'
import DropzoneS3Uploader from 'react-dropzone-s3-uploader'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import plusSquare from '@fortawesome/fontawesome-free-solid/faPlusSquare'
import '../stylesheets/imageUploader.sass'
import config from '../config';

export default class S3Uploader extends Component {

  handleFinishedUpload = info => {
    this.props.finished && this.props.finished(info.signedUrl.split('?')[0])
  }

  render() {
    const headers = { 'Authorization': `Bearer ${this.props.token}` }
    const uploadOptions = {
      server: config.API_BASE_URL,
      signingUrlQueryParams: { uploadType: this.props.type },
      signingUrlHeaders: headers,
      signingUrl: `/s3/sign/${this.props.path}`
    }
    const s3Url = 'kegmeistersdevelopment.s3.amazonaws.com'

    return (
      <DropzoneS3Uploader
        onFinish={this.handleFinishedUpload}
        s3Url={s3Url}
        maxSize={1024 * 1024 * 5}
        upload={uploadOptions}
        className={'image_uploader'}
        style={this.props.style}
        filename={this.props.filename}
        disablePreview={true}
        accept="image/jpeg, image/png"
      >
        <div className={'icon-wrapper'}>
          <div>
            <FontAwesomeIcon style={{ 'height': 150, 'width': 150 }} icon={plusSquare} />
          </div>
        </div>
      </DropzoneS3Uploader>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/ImageUpload.jsx